import { Environment } from 'src/app/interfaces';

export const environment: Environment = {
  production: false,
  userUrl: 'https://dev.mijn.hallobuurtvervoer.nl/',
  firebase: {
    apiKey: 'AIzaSyCaTdCKfVG0kVAjbfNKXMhfRQfzBlWUiu8',
    authDomain: 'wemaron-buurtvervoer.firebaseapp.com',
    projectId: 'wemaron-buurtvervoer',
    storageBucket: 'wemaron-buurtvervoer.appspot.com',
    messagingSenderId: '451062674757',
    appId: '1:451062674757:web:9345a6bfc259cd36cefa2c',
    measurementId: 'G-JZHLB437HG',
  },
  functionsUrl: 'https://europe-west1-wemaron-buurtvervoer.cloudfunctions.net',
  defaultOrgId: 'wemaron',
  routes: [
    'actions',
    'login',
    'plannen',
    'users',
    'employees',
    'adminTools',
    'adminToolsSetupPaymentMethods',
    'deletedRides',
    'settings',
    'scheduleLanding',
    'availabilityOverview',
    'scheduleEmployees',
    'schedule',
    'dayparts',
    'selectingOrganisation',
    'set',
    'daypartPlanning',
    'ridePreparation',
    'financial',
  ],
  organisation: {
    id: '',
    image:
      'https://firebasestorage.googleapis.com/v0/b/buurtvervoer-wijkbijduurstede.appspot.com/o/Afbeelding%20voor%20Login%20WIjkse%20dienst-03.svg?alt=media&token=6baed3a5-000d-4462-a241-dc8b9f4b5a0a',
  },
};
